/**
 * Splits a string by commas or spaces into an array, or returns null if empty.
 * Use before sending name array fields (middle_names, additional_family_names) to the API.
 */
export function splitNameArray(value: string | null): string[] | null {
  if (!value) return null;
  const items = value.split(/[,\s]+/).filter(Boolean);
  return items.length > 0 ? items : null;
}

/**
 * Initials for a user bubble, derived from a username — the API exposes no
 * real names for monitoring users. Separator-delimited usernames take the
 * first letter of the first two parts ("laura.hansen" → "LH"); single-word
 * usernames fall back to their first two characters ("lhansen" → "LH").
 */
export function getInitials(username: string): string {
  const parts = username.split(/[._\-\s]+/).filter(Boolean);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  return username.slice(0, 2).toUpperCase();
}

export interface NameParts {
  given_name: string | null;
  family_name: string | null;
  middle_names: string | null;
  name_particle: string | null;
  additional_family_names: string | null;
  name_suffix: string | null;
  title_before: string | null;
  title_after: string | null;
  name_order_given_first: boolean;
}

export function buildNamePreview(model: NameParts): string {
  const givenPart = [model.given_name, model.middle_names];
  const familyPart = [
    model.name_particle,
    model.family_name,
    model.additional_family_names,
    model.name_suffix,
  ];

  const givenFirst = model.name_order_given_first !== false;
  const nameParts = givenFirst
    ? [...givenPart, ...familyPart]
    : [...familyPart, ...givenPart];

  return [model.title_before, ...nameParts, model.title_after]
    .filter(Boolean)
    .join(" ");
}
